import { Inject, Injectable } from '@angular/core';
import { API_ENDPOINTS, ApiEndpoints, ApiResponse } from '@contracts';
import { ApiCilent } from '@core';
import { map, Observable } from 'rxjs';
import {
  CreateUserReq,
  DeleteUserReq,
  GetUsersResponseDto,
  UpdateUserReq,
} from '../types/user.dto';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private http: ApiCilent,
    @Inject(API_ENDPOINTS)
    private readonly endpoint: ApiEndpoints,
  ) {}
  userEndpoint = this.endpoint.user;
  getListUser(): Observable<GetUsersResponseDto> {
    return this.http
      .get<ApiResponse<GetUsersResponseDto>>(this.userEndpoint.list)
      .pipe(map((res) => res.meta.response_data));
  }

  createUser(
    body: CreateUserReq,
  ): Observable<ApiResponse<{ generated_password: string }>> {
    return this.http.post<ApiResponse<{ generated_password: string }>>({
      ...this.userEndpoint.create,
      body,
    });
  }

  editUser(body: UpdateUserReq): Observable<ApiResponse<void>> {
    return this.http.put<ApiResponse<void>>({
      ...this.userEndpoint.update,
      body,
    });
  }

  deleteUser(
    body: DeleteUserReq,
  ): Observable<ApiResponse<GetUsersResponseDto>> {
    return this.http.delete<ApiResponse<GetUsersResponseDto>>({
      ...this.userEndpoint.update,
      body,
    });
  }
}
